import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Link } from 'react-router-dom'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { toaster, Spinner } from 'evergreen-ui';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import 'react-phone-input-2/lib/style.css'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import host from '../../assets/js/Host';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import imagg from '../../assets/img/logo.png'

const styles = theme => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundColor:'#ffa450',
    display:'flex',
    alignItems:'center',
    justifyContent: 'center',
    height:'100vh',
    width:'100%',
  },
  paper: {
    height:'100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent:'center',
  },
  avatar: {
    margin: 10,
    backgroundColor: '#ffa450',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: 30,
  },
  submit: {
    marginTop: 50,
    width: 200,
  },
});

class SignInSide extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      phone: '',
      name: '',
      password: '',
      government:'',
      city:'',
      nameM:'',
      spinBtn: false,
    }
  }
  signUp(e) {

    e.preventDefault()
    axios.post(host + `users/auth/register`, {
      phone: this.state.phone,
      password: this.state.password,
      name: this.state.name,
      government: this.state.government,
      city: this.state.city,
      // agent:this.state.nameM,
      player_id: 'playerId',
    })
      .then(response => {
        window.location.href = "/login";
        this.setState({ spinBtn: false })
      })
      .catch(error => {
        console.log(error.response.data);
          if(error.response.data.message==='Phone number is already in use with another account'){
          this.setState({ spinBtn: false })
          toaster.danger(" رقم الهاتف موجود مسبقا ");
          }
          else{
            this.setState({ spinBtn: false })
            toaster.danger(error.response.data.message);
          }
      });
  }
  render() {
    const { classes } = this.props;
    return (
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <Grid item xs={false}  md={7} lg={7} className={classes.image} id='hideenlogo' >
          <img style={{width:'50%'}} src={imagg} alt='logo' />
        </Grid>
        <Grid item xs={12}  md={5} lg={5} component={Paper} elevation={6} square>
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              انشاء حساب
          </Typography>
            <div className={classes.form} noValidate>
              <div id='field1_ah'>
                <input autoComplete='off' type='text' placeholder=' اسم المتجر' id='InputTExtDash22' style={{ width: 260, textAlign:'center',  }}
                  onChange={(e) => this.setState({ name: e.target.value })} />
              </div>
              <div id='field1_ah'>
                <input autoComplete='off' type='number' placeholder=' رقم الهاتف ' id='InputTExtDash22' style={{ width: 260, textAlign:'center',  }}
                  onChange={(e) => this.setState({ phone: e.target.value })} />
              </div>
              <div id='field1_ah'>
                <input autoComplete='off' type='password' placeholder=' كلمه المرور ' id='InputTExtDash22' style={{ width: 260, textAlign:'center',  }}
                  onChange={(e) => this.setState({ password: e.target.value })} />
              </div>
              <div id='field1_ah'>
                <input autoComplete='off' type='text' placeholder=' المحافظه ' id='InputTExtDash22' style={{ width: 260, textAlign:'center',  }}
                  onChange={(e) => this.setState({ government: e.target.value })} />
              </div>
              <div id='field1_ah'>
                <input autoComplete='off' type='text' placeholder=' المنطقه ' id='InputTExtDash22' style={{ width: 260, textAlign:'center',  }}
                  onChange={(e) => this.setState({city : e.target.value })} />
              </div>
              <div id='field1_ah'>
                <input autoComplete='off' type='text' placeholder=' اسم المندوب ( اختياري )' id='InputTExtDash22' style={{ width: 260, textAlign:'center',  }}
                  onChange={(e) => this.setState({ nameM: e.target.value })} />
              </div>
              <div id='log1_ah'>
                {!this.state.spinBtn ? (
                  <div id='log_ah' onClick={(e) => {
                    this.setState({ spinBtn: true })
                    this.signUp(e)
                    
                  }}>انشاء</div>
                ) : (
                    <div id='log_ah' ><Spinner size={24} /></div>
                  )}
              </div>
              <div id='forGGetContiner'>
                <Link to='/login'>لدي حساب</Link>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    );
  }
}
SignInSide.propTypes = {
  classes: PropTypes.object.isRequired,
}
export default withRouter(withStyles(styles)(SignInSide))